import { render, staticRenderFns } from "./termsofservice.vue?vue&type=template&id=7255b596"
import script from "./termsofservice.vue?vue&type=script&lang=js"
export * from "./termsofservice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports